import { render, staticRenderFns } from "./DeleteSiteModal.vue?vue&type=template&id=59e228da"
import script from "./DeleteSiteModal.vue?vue&type=script&lang=ts"
export * from "./DeleteSiteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports